import { api } from "./client";
import { getActiveLang } from "../i18n";

export type BookingPayload = {
  serviceKey: string;
  fullName: string;
  email: string;
  phone: string;
  formData: Record<string, string>;
};

export async function postBookingInquiry(
  payload: BookingPayload,
): Promise<{ ok: true }> {
  const language = getActiveLang();
  const { data } = await api.post<{ ok: true }>(
    "/api/bookings/inquiry/",
    { ...payload, language },
  );
  return data;
}

export async function postCalendlyStart(
  payload: BookingPayload,
): Promise<{ id: string }> {
  const language = getActiveLang();
  const { data } = await api.post<{ id: string }>(
    "/api/bookings/calendly-start/",
    { ...payload, language },
  );
  return data;
}

export async function postBookingCheckout(
  payload: BookingPayload,
): Promise<{ url: string | null }> {
  const language = getActiveLang();
  const { data } = await api.post<{ url: string | null }>(
    "/api/bookings/checkout/",
    { ...payload, language },
  );
  return data;
}
